// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__ekRM2","content":"profile_content__xh7Ud"};